import type { ChatListFilter, ChatThread } from '../model/types';
import { mergeThreadWithExisting } from './mergeThreadWithExisting';

function threadMatchesFilter(thread: ChatThread, filter: ChatListFilter): boolean {
  if (filter === 'archived') {
    return thread.isArchived;
  }

  if (thread.isArchived) {
    return false;
  }

  if (filter === 'all') {
    return true;
  }

  return thread.kind === filter;
}

function mergeApiThreadsWithExisting(
  apiThreads: ChatThread[],
  localThreads: ChatThread[],
): ChatThread[] {
  const localById = new Map(localThreads.map((thread) => [thread.id, thread]));

  return apiThreads.map((thread) => {
    const existing = localById.get(thread.id);
    return existing ? mergeThreadWithExisting(existing, thread) : thread;
  });
}

export function mergeThreadsWithLocalOnly(
  apiThreads: ChatThread[],
  localThreads: ChatThread[],
  filter: ChatListFilter,
  excludedLocalThreadIds: ReadonlySet<number> = new Set(),
): ChatThread[] {
  const mergedApiThreads = mergeApiThreadsWithExisting(apiThreads, localThreads);
  const apiIds = new Set(mergedApiThreads.map((thread) => thread.id));
  const localOnly = localThreads.filter(
    (thread) =>
      !apiIds.has(thread.id) &&
      !excludedLocalThreadIds.has(thread.id) &&
      threadMatchesFilter(thread, filter),
  );

  if (!localOnly.length) {
    return mergedApiThreads;
  }

  return [...mergedApiThreads, ...localOnly].sort((left, right) => {
    const leftTime = left.updatedAt?.getTime() ?? 0;
    const rightTime = right.updatedAt?.getTime() ?? 0;

    return rightTime - leftTime || right.id - left.id;
  });
}
